(() => {
  if (window.FHERSAMVariantMediaFilterLoaded) return;
  window.FHERSAMVariantMediaFilterLoaded = true;

  function getSelectedColor(productSection) {
    const fieldsets = productSection.querySelectorAll('fieldset');

    for (const fieldset of fieldsets) {
      const legend = fieldset
        .querySelector('legend')
        ?.textContent.trim()
        .toLowerCase();

      if (legend?.startsWith('color') || legend?.startsWith('colour')) {
        return fieldset.querySelector('input:checked')?.value.trim() || '';
      }
    }

    const selects = productSection.querySelectorAll('select');

    for (const select of selects) {
      const label = productSection
        .querySelector(`label[for="${CSS.escape(select.id)}"]`)
        ?.textContent.trim()
        .toLowerCase();

      if (
        label?.includes('color') ||
        label?.includes('colour') ||
        select.name.toLowerCase().includes('color')
      ) {
        return select.options[select.selectedIndex]?.text.trim() || '';
      }
    }

    return '';
  }

  function getColorFromAlt(image) {
    const altText = image?.getAttribute('alt')?.trim() || '';
    const parts = altText
      .split('|')
      .map((part) => part.trim())
      .filter(Boolean);

    return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
  }

  function filterProductMedia(productSection) {
    const selectedColor = getSelectedColor(productSection).toLowerCase();
    const gallery = productSection.querySelector('media-gallery');

    if (!selectedColor || !gallery) return;

    gallery.querySelectorAll('.product__media-item').forEach((mediaItem) => {
  const imageColor = getColorFromAlt(mediaItem.querySelector('img'));
  const shouldHide = imageColor && imageColor !== selectedColor;

  mediaItem.hidden = shouldHide;
  mediaItem.style.display = shouldHide ? 'none' : '';
});

gallery.querySelectorAll('.thumbnail-list__item').forEach((thumbnail) => {
  const imageColor = getColorFromAlt(thumbnail.querySelector('img'));
  const shouldHide = imageColor && imageColor !== selectedColor;

  thumbnail.hidden = shouldHide;
  thumbnail.style.display = shouldHide ? 'none' : '';
});
const mobileSlider = gallery.querySelector('slider-component');
if (mobileSlider && typeof mobileSlider.resetPages === 'function') {
  mobileSlider.resetPages();
}
const visibleMediaCount = gallery.querySelectorAll(
  '.product__media-item:not([hidden])'
).length;

const sliderButtons = gallery.querySelector('.slider-buttons');

if (sliderButtons && visibleMediaCount > 1) {
  sliderButtons.classList.remove('small-hide');
}
const variantCounter = gallery.querySelector('.fhersam-variant-counter');

if (variantCounter) {
  const current = variantCounter.querySelector('.slider-counter--current');
  const total = variantCounter.querySelector('.slider-counter--total');

  if (current) current.textContent = '1';
  if (total) total.textContent = visibleMediaCount;

  variantCounter.style.visibility = 'visible';
}
    const activeMedia = gallery.querySelector(
      '.product__media-item.is-active'
    );

    if (activeMedia?.hidden) {
      const firstVisibleMedia = gallery.querySelector(
        '.product__media-item:not([hidden])'
      );

      const mediaId = firstVisibleMedia?.dataset.mediaId;

      if (mediaId && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, true);
      }
    }
  }

  function filterAllProducts() {
    document
      .querySelectorAll('[id^="MainProduct-"]')
      .forEach(filterProductMedia);
  }

  document.addEventListener('DOMContentLoaded', filterAllProducts);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const sectionId = event?.data?.sectionId;
    if (!sectionId) return;

    const productSection = document.querySelector(`#MainProduct-${sectionId}`);
    if (!productSection) return;

    filterProductMedia(productSection);
  });
}

  document.addEventListener('shopify:section:load', filterAllProducts);
})();